"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllegroTransformGlobalSymbolGenerator = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const TransformObject_1 = require("../../../../Shared/HierarchicalTransformer/TransformObjects/TransformObject");
const TransformProject_1 = require("../../../../Shared/HierarchicalTransformer/TransformObjects/TransformProject");
const TransformProjectModule_1 = require("../../../../Shared/HierarchicalTransformer/TransformObjects/TransformProjectModule");
const TransformModule_1 = require("../../../../Shared/HierarchicalTransformer/TransformObjects/TransformModule");
const TransformModulePinConnection_1 = require("../../../../Shared/HierarchicalTransformer/TransformObjects/TransformModulePinConnection");
const TransformSchematic_1 = require("../../../../Shared/HierarchicalTransformer/TransformObjects/TransformSchematic");
const allegroLayers_1 = require("../../../allegroLayers");
const AllegroRecordHelpers_1 = require("../AllegroRecordHelpers");
const AllegroResolved_1 = require("../AllegroResolved");
const VALUE_LABEL_LAYER = allegroLayers_1.AllegroSchLayerMap[sigma_engine_shared_1.DesignModels.SchLayerType.ValueLabel].id;
class AllegroTransformGlobalSymbolGenerator {
    constructor() {
        this.runsFor = [
            TransformSchematic_1.TransformSchematic,
        ];
    }
    *generate(schematic, rootContext) {
        const project = TransformObject_1.TransformObject.FindParent(schematic, TransformProject_1.TransformProject);
        if (project === null) {
            return;
        }
        const pageNum = schematic.instance.hierarchyEntry.loaded.pageNum;
        const design = rootContext.resolved.designs.find((d) => d.pageNum === pageNum);
        if (design === undefined) {
            return;
        }
        for (const symbol of design.powerSymbols) {
            yield* emit(schematic, project, rootContext, symbol, design);
        }
    }
}
exports.AllegroTransformGlobalSymbolGenerator = AllegroTransformGlobalSymbolGenerator;
function* emit(schematic, project, rootContext, resolved, design) {
    const component = rootContext.componentsByCellName.get(resolved.cellName);
    if (component === undefined || resolved.rawInstance.kind !== 'power') {
        return;
    }
    const symbolNetName = resolved.value ?? null;
    const projectModule = new TransformProjectModule_1.TransformProjectModule(project, {
        name: resolved.refdes,
        component,
        value: symbolNetName ?? undefined,
        metadata: symbolNetName !== null ? rootContext.netAttributesByName.get(symbolNetName) : undefined,
        model: buildSigmaModel(resolved, symbolNetName),
    });
    yield projectModule;
    yield new TransformModule_1.TransformModule(schematic, {
        ref: resolved.moduleRef,
        footprintRef: (0, AllegroResolved_1.allegroSymbolRefForCell)(resolved.cellName, resolved.view, resolved.sectionNumber),
        center: resolved.center,
        transform: resolved.transform,
        name: resolved.refdes,
        drawProperties: buildDrawProperties(resolved, symbolNetName ?? resolved.cellName, design.defaultTextStyle),
    }, component, projectModule);
    for (const pin of resolved.pins) {
        yield new TransformModulePinConnection_1.TransformModulePinConnection(schematic, {
            position: pin.absolutePosition,
            connection: {
                moduleRef: resolved.moduleRef,
                moduleName: resolved.refdes,
                pinRef: pin.ref,
                skipPositionalCombobulation: true,
                appliesNetName: pin.netName !== null ?
                    { label: pin.netName, labelType: 'system', strategyMetadata: { xconNetName: pin.netName } }
                    : null,
            },
        });
    }
}
function buildSigmaModel(resolved, netName) {
    if (resolved.signalKind === 'ground') {
        return { modelId: 'ground.standard' };
    }
    const model = { modelId: 'supply.standard' };
    if (resolved.signalVoltage !== undefined) {
        model.inferenceReport = {
            parameters: { voltage: { source: 'parser', value: resolved.signalVoltage } },
        };
    }
    else if (netName !== null) {
        try {
            const voltage = (0, sigma_engine_shared_1.parseNumericalSIValue)(netName, sigma_engine_shared_1.BoundaryCharacteristicSIDefinitions['voltage']);
            model.inferenceReport = {
                parameters: { voltage: { source: 'module-value', value: voltage } },
            };
        }
        catch {
        }
    }
    return model;
}
function buildDrawProperties(resolved, netName, textStyle) {
    if (resolved.rawInstance.kind !== 'power') {
        return {};
    }
    const center = resolved.center;
    let pos = [center[0], center[1]];
    for (const label of (0, AllegroRecordHelpers_1.iterateVisualLabels)(resolved.rawInstance.record)) {
        if (label.propertyName?.toUpperCase() === 'VALUE' && label.position !== null) {
            pos = [
                center[0] + label.position.x * AllegroRecordHelpers_1.CADENCE_SCH_UNIT_TO_MM,
                center[1] + label.position.y * AllegroRecordHelpers_1.CADENCE_SCH_UNIT_TO_MM,
            ];
            break;
        }
    }
    return {
        Value: {
            value: netName,
            pos,
            layer: VALUE_LABEL_LAYER,
            angle: 0,
            justify: [-1, -1],
            size: textStyle.size,
            thickness: 1,
            hidden: false,
            mirror: [false, false],
        },
    };
}
//# sourceMappingURL=AllegroTransformGlobalSymbolGenerator.js.map